export default function removeNumberFromString(str) {
    return str.replace(/\d+/g, '');
}